import React from 'react';
import './CompletionMeter.css';

const CompletionMeter = ({ percentage }) => {
  const radius = 50;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  let color;
  if (percentage < 50) {
    color = '#f44336'; // Red
  } else if (percentage < 80) {
    color = '#ff9800'; // Orange/Yellow
  } else {
    color = '#4caf50'; // Green
  }

  return (
    <div className="meter-container">
      <svg className="meter-svg" width="120" height="120" viewBox="0 0 120 120">
        <circle
          className="meter-background"
          cx="60"
          cy="60"
          r={radius}
          strokeWidth="10"
        />
        <circle
          className="meter-progress"
          cx="60"
          cy="60"
          r={radius}
          strokeWidth="10"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          stroke={color}
        />
        <text x="50%" y="50%" textAnchor="middle" dy=".3em" className="meter-text">
          {`${Math.round(percentage)}%`}
        </text>
      </svg>
      <div className="meter-label">Post Strength</div>
    </div>
  );
};

export default CompletionMeter;